export default __webpack_public_path__ + "static/SSSpyView_screenshot-1@2x-0dcd3c37e7512e7565922e1725328ed1.jpg";